import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const Strings = require('../../../../app/shared/Strings');
const ChannelStore = require('../../stores/channel_store_reflux');
const ProjectStore = require('../../stores/ProjectStore');
const AnalyticsActions = require('../../actions/AnalyticsActions');
const AnalyticsStore = require('../../stores/AnalyticsStore');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const FeatureUtil = require('../../../../app/shared/FeatureUtil');
import Navigator from '../../Navigator';
import MainNav from '../DashboardNew/Menu/MainNav';
import SubNav from '../nav/SubNav';
import BackButton from '../nav/BackButton';
import BreadCrumbs from '../common/BreadCrumbs';
import LoadingMainContent from '../loading/LoadingMainContent';

import ShortCourseListAnalyticsView from './ShortCourseListAnalyticsView';

const propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            channelId: PropTypes.string.isRequired,
            projectId: PropTypes.string.isRequired,
            shortCourseId: PropTypes.string
        })
    }).isRequired,
    history: PropTypes.object.isRequired,
};

const defaultProps = {};

class ProjectShortCourseAnalyticsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelStoreState: ChannelStore.getState(),
            projectStoreState: ProjectStore.getStateProject(parseInt(props.match.params.projectId, 10)),
            analyticsStoreState: AnalyticsStore.getState(),
            getOverviewActionId: null
        };

        this.backHandler = this.backHandler.bind(this);
        this.onShortCourseClick = this.onShortCourseClick.bind(this);
        this.checkToGetAnalytics = this.checkToGetAnalytics.bind(this);
        this.unsubscribes = [
            ChannelStore.listen(this.onChannelStoreChange.bind(this)),
            AnalyticsStore.listen(this.onAnalyticsStoreChage.bind(this)),
            ProjectStore.listen(this.onProjectStoreChange.bind(this))
        ];
    }

    componentDidMount() {
        this.checkToGetAnalytics(this.state.channelStoreState, this.state.projectStoreState);
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onChannelStoreChange(state) {
        if (state.initialized) {
            const currentChannel = state.channelsAndOrgs.find(ch => ch.id === parseInt(this.props.match.params.channelId, 10));
            if (!currentChannel) { // channel does not exist or user does not have permissions in channel
                Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.AUTHORING)
                return;
            }
        }

        this.setState({ channelStoreState: state }, () => {
            this.checkToGetAnalytics(state, this.state.projectStoreState);
        });
    }

    onProjectStoreChange(state) {
        const newState = ProjectStore.getStateProject(parseInt(this.props.match.params.projectId, 10));
        if (newState.initialized && !newState.shortCourseProject) { // project does not exist or user does not have permissions in channel
            Navigator.goToDashboardAuthorView.bind(this, this.props.history, Globals.view_tokens.dashboard.AUTHORING)
            return;
        }

        this.setState({ projectStoreState: newState }, () => {
            this.checkToGetAnalytics(this.state.channelStoreState, newState);
        });
    }

    onAnalyticsStoreChage(state) {
        let additionalState = {};
        if (state.action.id === this.state.getOverviewActionId) {
            additionalState = { ...additionalState, getOverviewActionId: null };
        }

        this.setState({ analyticsStoreState: state, ...additionalState });
    }

    checkToGetAnalytics(channelStoreState, projectStoreState) {
        if (channelStoreState.initialized && projectStoreState.initialized) {
            const currentChannel = channelStoreState.channelsAndOrgs.find(ch => ch.id === parseInt(this.props.match.params.channelId, 10));
            const currentProject = projectStoreState.shortCourseProject;

            // account does not have detailed analytics
            if (!FeatureUtil.hasDetailedAnalytics(currentChannel.channel_permissions)) {
                console.warn('Account does not have Detailed Analytics feature');
                this.backHandler();
                return;
            }

            // user does not have project/channel permissions to view analytics
            if (!PermissionsUtil.viewDetailedProjectAnalytics(currentChannel.user_permissions, currentProject.user_permissions)) {
                this.backHandler();
                return;
            }

            if (!this.state.analyticsStoreState.projectShortCourseOverview[currentProject.id]) {
                const actionId = uuid.v4();
                this.setState({ getOverviewActionId: actionId }, () => {
                    AnalyticsActions.getProjectShortCourseOverview(actionId, { id: currentProject.id });
                });
            }
        }
    }

    backHandler() {
        this.props.history.goBack();
    }

    onShortCourseClick(shortCourseId) {
        Navigator.goToShortCourseAnalyticsView(this.props.history, this.props.match.params.channelId, this.props.match.params.projectId, shortCourseId);
    }

    render() {
        const currentChannelId = parseInt(this.props.match.params.channelId, 10);
        const projectId = parseInt(this.props.match.params.projectId, 10);

        if (
            !this.state.channelStoreState.initialized
            || !this.state.projectStoreState.initialized
            || !this.state.analyticsStoreState.projectShortCourseOverview[projectId]
        ) {
            return <LoadingMainContent />
        }

        const currentChannel = this.state.channelStoreState.channelsAndOrgs.find(c => c.id === currentChannelId);
        const currentProject = this.state.projectStoreState.shortCourseProject;
        const shortCourses = this.state.analyticsStoreState.projectShortCourseOverview[projectId];

        return (
            <div>
                <MainNav
                    onClickBrandLogo={() => Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.match.params.channelId)}
                />
                <div className="container-fluid main-container">
                    <SubNav containerClassName="subnav__container-fluid">
                        <BackButton backHandler={this.backHandler}/>
                        <div className="view-info-container">
                            <div className="view-title">
                                {Strings['en'].page_title.PROJECT_COURSE_ANALYTICS}
                            </div>
                            <div className="view-description">
                                <BreadCrumbs
                                    links={[
                                        {
                                            href: Navigator.paths.dashboard_author_channel_view(this.props.match.params.channelId),
                                            text: currentChannel.name
                                        },
                                        {
                                            href: Navigator.paths.project_view(this.props.match.params.channelId, this.props.match.params.projectId),
                                            text: currentProject.name
                                        }

                                    ]}
                                />
                            </div>
                        </div>
                    </SubNav>

                    <ShortCourseListAnalyticsView
                        shortCourses={shortCourses}
                        onShortCourseClick={this.onShortCourseClick}
                        shortCourseId={this.props.match.params.shortCourseId}
                        projectId={this.props.match.params.projectId}
                        channelId={currentChannelId}
                    />
                </div>
            </div>
        );
    }
}

ProjectShortCourseAnalyticsView.propTypes = propTypes;
ProjectShortCourseAnalyticsView.defaultProps = defaultProps;

export default withRouter(ProjectShortCourseAnalyticsView);